/* PURCHASING MANAGEMENT */
import FarmersPage from '@/pages/commercialisation/purchasingManagement/purchaseContracts/farmer/FarmersPage.vue';
import FarmerDetailPage from '@/pages/commercialisation/purchasingManagement/purchaseContracts/farmer/FarmerDetailPage.vue';
import NewFarmerPage from '@/pages/commercialisation/purchasingManagement/purchaseContracts/farmer/NewFarmerPage.vue';
import NewFarmerWizzardPage from '@/pages/commercialisation/purchasingManagement/purchaseContracts/farmer/NewFarmerWizzardPage.vue';
import NewFieldPage from '@/pages/commercialisation/purchasingManagement/purchaseContracts/field/NewFieldPage.vue';
import NewCropPage from '@/pages/commercialisation/purchasingManagement/purchaseContracts/crop/NewCropPage.vue';
import NewContractPage from '@/pages/commercialisation/purchasingManagement/purchaseContracts/contract/NewContractPage.vue';
import ContractsPage from '@/pages/commercialisation/purchasingManagement/purchaseContracts/contract/ContractsPage.vue';

/* SALES ORDERS */
import QueryOrders from '@/pages/commercialisation/salesOrders/QueryOrders.vue';
import OrderDetail from '@/pages/commercialisation/salesOrders/OrderDetail.vue';
import OrderInquiry from '@/pages/commercialisation/salesOrders/OrderInquiry.vue';
import NewMixtedOrderLine from '@/pages/commercialisation/salesOrders/NewMixtedOrderLine.vue';
import FrmNewOrder from '@/pages/commercialisation/salesOrders/FrmNewOrder.vue';
import FrmOrderCompleteProducto from '@/pages/commercialisation/salesOrders/FrmOrderCompleteProducto.vue';
import FrmNewTextOrderLine from '@/pages/commercialisation/salesOrders/FrmNewTextOrderLine.vue';

/* EXPEDITION */
import FrmExpeditionDocumentNew from '@/pages/commercialisation/expedition/FrmExpeditionDocumentNew.vue';
import FrmExpedition from '@/pages/commercialisation/expedition/FrmExpedition.vue';
import FrmExpeditionDocumentCompleteData from '@/pages/commercialisation/expedition/FrmExpeditionDocumentCompleteData.vue';
import FrmExpeditionDocument from '@/pages/commercialisation/expedition/FrmExpeditionDocument.vue';
import FrmExpeditionDocumentAddPale from '@/pages/commercialisation/expedition/FrmExpeditionDocumentAddPale.vue';
import FrmExpeditionEditLines from '@/pages/commercialisation/expedition/FrmExpeditionEditLines.vue';
import FrmExpeditionSalesReceipt from '@/pages/commercialisation/expedition/FrmExpeditionSalesReceipt.vue';
import FrmExpeditionSalesReceiptData from '@/pages/commercialisation/expedition/FrmExpeditionSalesReceiptData.vue';

import FrmExpeditionDocumentAddPaleNoSales from '@/pages/commercialisation/expedition/noSalesOrder/FrmExpeditionDocumentAddPaleNoSales.vue';
import FrmExpeditionNewNoSalesOrder from '@/pages/commercialisation/expedition/noSalesOrder/FrmExpeditionNewNoSalesOrder.vue';
import FrmExpeditionDocumentNoSales from '@/pages/commercialisation/expedition/noSalesOrder/FrmExpeditionDocumentNoSales.vue';
import FrmExpeditionDocumentNoSalesCompleteData from '@/pages/commercialisation/expedition/noSalesOrder/FrmExpeditionDocumentNoSalesCompleteData.vue';

// Envases retornables
// import FrmReturnablePackagingHome from '@/pages/commercialisation/returnablesManagement/FrmReturnablePackagingHome.vue';
// import FrmNewReturnablesMovements from '@/pages/commercialisation/returnablesManagement/FrmNewReturnablesMovements.vue';

export default [
  {
    path: '/commercialisation/expedition/frmExpeditionDocumentAddPale',
    component: FrmExpeditionDocumentAddPale,
  },
  {
    path: '/commercialisation/expedition/frmExpeditionDocumentNew',
    component: FrmExpeditionDocumentNew,
  },
  {
    path: '/commercialisation/expedition/frmExpedition',
    component: FrmExpedition,
  },
  {
    path: '/commercialisation/expedition/frmExpeditionDocumentCompleteData',
    component: FrmExpeditionDocumentCompleteData,
    props: true,
  },
  {
    path: '/commercialisation/expedition/frmExpeditionDocument/',
    component: FrmExpeditionDocument,
    props: true,
  },
  {
    path: '/commercialisation/expedition/frmExpeditionEditLines',
    component: FrmExpeditionEditLines,
  },
  {
    path: '/commercialisation/expedition/frmExpeditionSalesReceipt',
    component: FrmExpeditionSalesReceipt,
  },
  {
    path: '/commercialisation/expedition/frmExpeditionSalesReceiptData',
    component: FrmExpeditionSalesReceiptData,
  },
  {
    path: '/commercialisation/expedition/noSalesOrder/frmExpeditionNewNoSalesOrder',
    component: FrmExpeditionNewNoSalesOrder,
  },
  {
    path: '/commercialisation/expedition/noSalesOrder/frmExpeditionDocumentNoSalesCompleteData',
    component: FrmExpeditionDocumentNoSalesCompleteData,
  },
  {
    path: '/commercialisation/expedition/noSalesOrder/frmExpeditionDocumentNoSales',
    component: FrmExpeditionDocumentNoSales,
  },
  {
    path: '/commercialisation/expedition/noSalesOrder/frmExpeditionDocumentAddPaleNoSales',
    component: FrmExpeditionDocumentAddPaleNoSales,
  },

  {
    path: '/commercialisation/salesOrder/frmSalesOrder',
    component: QueryOrders,
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/commercialisation/contracts/frmContracts',
    component: FarmersPage,
  },
  {
    path: '/orderDetail/',
    component: OrderDetail,
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/orderInquiry/',
    component: OrderInquiry,
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/frmNewOrder',
    component: FrmNewOrder,
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/frmOrderCompleteProducto',
    component: FrmOrderCompleteProducto,
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/newMixtedOrderLine/',
    component: NewMixtedOrderLine,
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/frmNewTextOrderLine/',
    component: FrmNewTextOrderLine,
    meta: {
      useNewStyles: true,
    },
  },

  {
    path: '/new-farmer',
    component: NewFarmerPage,
  },
  {
    path: '/new-farmer-wizzard/',
    component: NewFarmerWizzardPage,
  },
  {
    path: '/farmers/:farmerID',
    component: FarmerDetailPage,
  },
  {
    path: '/new-field/',
    component: NewFieldPage,
    options: {
      props: {
        farmerId: 0,
      },
    },
  },
  {
    path: '/new-crop/',
    component: NewCropPage,
  },
  {
    path: '/new-contract/',
    component: NewContractPage,
  },
  {
    path: '/contracts/',
    component: ContractsPage,
  },
  {
    path: '/commercialisation/returnableManagement/frmReturnableManagement',
    asyncComponent: () => import('@/pages/commercialisation/returnablesManagement/FrmReturnablePackagingHome.vue'),
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/commercialisation/returnableManagement/frmNewReturnablesMovements',
    asyncComponent: () => import('@/pages/commercialisation/returnablesManagement/FrmNewReturnablesMovements.vue'),
    meta: {
      useNewStyles: true,
    },
  },
];
